// @ts-check
import React, { useState } from "react";
import { forgotPassword } from "../../../redux/auth/actions";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import parsePhoneNumber from "libphonenumber-js";
import { Toaster } from "../../../utils/toaster";
import { APP_CONST, AuthModals } from "../../../config/const";
import { Modal } from "react-bootstrap";
import useAuthModalHook from "../../../hooks/useAuthModalHook";

/**
 *
 * @param {string} mobileNumber
 * @returns {{phone:string;countryCode:string}}
 */
const getParsedMobileNumber = (mobileNumber) => {
  const phoneNumber = parsePhoneNumber("+" + mobileNumber);

  if (!phoneNumber) {
    return {
      phone: "",
      countryCode: "",
    };
  }

  return {
    phone: phoneNumber?.nationalNumber,
    countryCode: phoneNumber?.countryCallingCode,
  };
};

const ForgotPasswords = ({ show }) => {
  const { updateActiveAuthModal } = useAuthModalHook();
  const [mobileNumber, setMobileNumber] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  /**
   *
   * @param {React.FormEvent<HTMLFormElement>} e
   */
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!mobileNumber || mobileNumber === "") {
      Toaster(APP_CONST.TOAST_TYPE.ERROR, "Please enter mobile number");
      return;
    }
    setIsLoading(true);
    const response = await forgotPassword(getParsedMobileNumber(mobileNumber));
    setIsLoading(false);
    if (response) {
      Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "OTP sent");
      updateActiveAuthModal(AuthModals.ResetPassword);
    }
  };

  return (
    <Modal
      show={show}
      id="loginModal"
      className={"steps-canvas login-register forgot"}
      onHide={() => {
        console.log("working");
      }}
      placement={"end"}
      centered
    >
      <Modal.Header
        closeButton
        onClick={() => updateActiveAuthModal(null)}
        closeVariant="black"
      ></Modal.Header>
      <Modal.Body>
        <div className="inner-wrapper mb-5">
          <h2 className="title">Enter Phone Number</h2>

          <Form onSubmit={handleSubmit}>
            <Form.Group className="form-group" controlId="formBasicPassword">
              {/* <Form.Label>Phone Num</Form.Label> */}
              <PhoneInput
                country={"in"}
                countryCodeEditable={false}
                inputProps={{
                  name: "phone",
                  required: true,
                }}
                // onlyCountries={["in"]}
                inputStyle={{
                  padding: "10px 10px",
                  paddingLeft: "50px",
                }}
                onChange={(phone) => {
                  setMobileNumber(phone);
                }}
              />
            </Form.Group>

            <Button variant="primary" type="submit" disabled={isLoading}>
              {isLoading ? "Loading.." : "Get OTP"}
            </Button>
          </Form>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default ForgotPasswords;
